/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<ObjectMap>;
export function request(
  params: API.tms.customsDeclarationDetails.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationDetails/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
